import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RequirePermissions } from "@/app/router/guards";
import { PermissionCodes } from "@/shared/auth/permissions";
import { LazyPage } from "@/app/router/LazyPage";

const ReceiptsListPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.ReceiptsListPage })),
);
const ReceiptDetailPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.ReceiptDetailPage })),
);
const LotsListPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.LotsListPage })),
);
const LotDetailPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.LotDetailPage })),
);
const IssuesListPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.IssuesListPage })),
);
const IssueDetailPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.IssueDetailPage })),
);
const MovesListPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.MovesListPage })),
);
const MoveDetailPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.MoveDetailPage })),
);
const StockBoardPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.StockBoardPage })),
);
const StockReportPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.StockReportPage })),
);
const ExpiryBoardPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.ExpiryBoardPage })),
);
const ReservationsListPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({
    default: m.ReservationsListPage,
  })),
);
const CountsListPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.CountsListPage })),
);
const CountDetailPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.CountDetailPage })),
);
const DisposalsListPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.DisposalsListPage })),
);
const DisposalDetailPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.DisposalDetailPage })),
);
const FieldWmsHomePage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({ default: m.FieldWmsHomePage })),
);
const FieldMoveCreatePage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({
    default: m.FieldMoveCreatePage,
  })),
);
const FieldCountCreatePage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({
    default: m.FieldCountCreatePage,
  })),
);
const FieldStockPeekPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({
    default: m.FieldStockPeekPage,
  })),
);
const FieldExpiryPeekPage = lazy(() =>
  import("@/modules/warehouse").then((m) => ({
    default: m.FieldExpiryPeekPage,
  })),
);

export const warehouseOpsRoutes: RouteObject[] = [
          {
            element: (
              <RequirePermissions
                codes={[
                  PermissionCodes.WmsLotList, PermissionCodes.WmsLotManage,
                  PermissionCodes.WmsBalanceList,
                  PermissionCodes.WmsExpiryList, PermissionCodes.WmsExpiryManage,
                  PermissionCodes.WmsCountList, PermissionCodes.WmsCountManage, PermissionCodes.WmsStockManage,
                  PermissionCodes.WmsDisposalList, PermissionCodes.WmsDisposalManage,
                  PermissionCodes.WmsTransactionList, PermissionCodes.WmsTransactionManage, PermissionCodes.WmsTxnPost,
                  PermissionCodes.WmsReservationList, PermissionCodes.WmsReservationManage,
                  PermissionCodes.PurchaseManage,
                ]}
                match="any"
              />
            ),
            children: [
              {
                path: "wms/receipts",
                element: (
                  <LazyPage>
                    <ReceiptsListPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/receipts/:txnNo",
                element: (
                  <LazyPage>
                    <ReceiptDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/lots",
                element: (
                  <LazyPage>
                    <LotsListPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/lots/:lotCode",
                element: (
                  <LazyPage>
                    <LotDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/issues",
                element: (
                  <LazyPage>
                    <IssuesListPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/issues/:txnNo",
                element: (
                  <LazyPage>
                    <IssueDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/moves",
                element: (
                  <LazyPage>
                    <MovesListPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/moves/:txnNo",
                element: (
                  <LazyPage>
                    <MoveDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/stock",
                element: (
                  <LazyPage>
                    <StockBoardPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/stock-report",
                element: (
                  <LazyPage>
                    <StockReportPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/reservations",
                element: (
                  <LazyPage>
                    <ReservationsListPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/expiry",
                element: (
                  <LazyPage>
                    <ExpiryBoardPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/counts",
                element: (
                  <LazyPage>
                    <CountsListPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/counts/:countNo",
                element: (
                  <LazyPage>
                    <CountDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/disposals",
                element: (
                  <LazyPage>
                    <DisposalsListPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/disposals/:disposalNo",
                element: (
                  <LazyPage>
                    <DisposalDetailPage />
                  </LazyPage>
                ),
              },
            ],
          },
];

export const warehouseFieldRoutes: RouteObject[] = [
          {
            element: (
              <RequirePermissions
                codes={[
                  PermissionCodes.WmsBalanceList, PermissionCodes.WmsExpiryList,
                  PermissionCodes.WmsTransactionList, PermissionCodes.WmsTransactionManage, PermissionCodes.WmsTxnPost,
                  PermissionCodes.WmsCountList, PermissionCodes.WmsCountManage,
                ]}
                match="any"
              />
            ),
            children: [
              {
                path: "wms",
                element: (
                  <LazyPage>
                    <FieldWmsHomePage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/move",
                element: (
                  <LazyPage>
                    <FieldMoveCreatePage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/count",
                element: (
                  <LazyPage>
                    <FieldCountCreatePage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/stock",
                element: (
                  <LazyPage>
                    <FieldStockPeekPage />
                  </LazyPage>
                ),
              },
              {
                path: "wms/expiry",
                element: (
                  <LazyPage>
                    <FieldExpiryPeekPage />
                  </LazyPage>
                ),
              },
            ],
          },
];
